import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'osp-no-notification-found',
  standalone: true,
  imports: [TranslateModule],
  templateUrl: './no-notification-found.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NoNotificationFoundComponent {
  $isError = input(false, { alias: 'isError' });
}
